import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`;

export default Row;
